import {pathParameter} from "../../../utils/urlUtils";

export const getBasePagePartnerId = () => {
    return pathParameter('partnerId');
};

export const syncBasePagePartnerMode = (
    auth,
    {
        loginAsPartner,
        logoutFromPartner,
    }
) => {
    const hasPartnerIdParameter = Boolean(getBasePagePartnerId());

    if (!auth.isAdminAsPartner && hasPartnerIdParameter) {
        loginAsPartner();
    }

    if (auth.isAdminAsPartner && !hasPartnerIdParameter) {
        logoutFromPartner();
    }
};
